"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OperationKindType;
(function (OperationKindType) {
    OperationKindType["SeedNonceRevelation"] = "seed_nonce_revelation";
    OperationKindType["Delegation"] = "delegation";
    OperationKindType["Transaction"] = "transaction";
    OperationKindType["AccountActivation"] = "activate_account";
    OperationKindType["Origination"] = "origination";
    OperationKindType["Reveal"] = "reveal";
    OperationKindType["Endorsement"] = "endorsement";
    OperationKindType["Ballot"] = "ballot";
    OperationKindType["DoubleEndorsementEvidence"] = "double_endorsement_evidence";
    OperationKindType["DoubleBakingEvidence"] = "double_baking_evidence";
    OperationKindType["Proposal"] = "proposals";
})(OperationKindType = exports.OperationKindType || (exports.OperationKindType = {}));
var TezosParameterFormat;
(function (TezosParameterFormat) {
    TezosParameterFormat["Michelson"] = "michelson";
    TezosParameterFormat["Micheline"] = "micheline";
    TezosParameterFormat["MichelsonLambda"] = "michelsonlambda";
})(TezosParameterFormat = exports.TezosParameterFormat || (exports.TezosParameterFormat = {}));
//# sourceMappingURL=TezosChainTypes.js.map